import React from 'react';
import styled from '@emotion/styled';
import {
	CallToAction as BaseCallToAction,
	ICallToActionProps as IBaseCallToActionProps,
} from '../../../../ui';
import { ICallToActionTheme } from './ICallToActionTheme';
import { getCallToActionStyle } from './getCallToActionStyle';

interface ICallToActionProps extends IBaseCallToActionProps {
	callToActionTheme: ICallToActionTheme;
}

export const CustomStyledCallToAction = styled(
	BaseCallToAction,
)<ICallToActionProps>`
	${({ callToActionTheme }) => getCallToActionStyle(callToActionTheme)}
`;

export const CallToAction = ({
	callToActionTheme,
	...rest
}: ICallToActionProps) => (
	<CustomStyledCallToAction
		callToActionTheme={callToActionTheme}
		inverted={callToActionTheme !== 'grey'}
		{...rest}
	/>
);
